module.exports = __webpack_public_path__ + "img/slide5.fa380c1f.jpg";